import React from "react";
import { NavLink } from "react-router-dom";

function Sidebar({ id, isAdmin }) {
    return (
        <div className="menu-container">
            <nav class="navbar navbar-expand-lg navbar-light">
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#basicExampleNav" aria-controls="basicExampleNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="basicExampleNav">
                    <ul class="navbar-nav mr-auto">
                        <li className="nav-item linker">
                            <NavLink exact className="nav-link" to="/home/clinical-note/ward-summary">
                                <i className="fa fa-home"></i>
                                Back to Home
                            </NavLink>
                        </li>
                        {isAdmin && (
                            <>
                                <li className="nav-item linker">
                                    <NavLink className="nav-link " to="/home/staffing/dashboard">
                                        <i className="fa fa-th-large"></i>
                                        Dashboard
                                    </NavLink>
                                </li>
                                <li className="nav-item linker">
                                    <NavLink className="nav-link" to="/home/staffing/new">
                                        <i className="fa fa-user-plus"></i>
                                        Create New Staff
                                    </NavLink>
                                </li>

                                <li className="nav-item linker">
                                    <NavLink className="nav-link" to="/home/staffing/list">
                                        <i className="fa fa-users"></i>
                                        Manage Staff Information
                                    </NavLink>
                                </li>
                                <li className="nav-item linker">
                                    <NavLink className="nav-link" to="/home/staffing/annual-leave">
                                        <i className="fa fa-users"></i>
                                        Annual Leave
                                    </NavLink>
                                </li>
                            </>
                        )}

                        <li className="nav-item linker">
                            <NavLink className="nav-link" to="/home/staffing/profile/setting">
                                <i className="fa fa-cog"></i>
                                Account Setting
                            </NavLink>
                        </li>
                        <li className="nav-item linker">
                            <NavLink
                                className="nav-link"
                                exact={true}
                                to={{
                                    pathname: "/home/staffing/profile",
                                    search: `?ref=${id}`,
                                }}
                            >
                                <i className="fa fa-user-circle-o"></i>
                                Your Profile
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
}

export default Sidebar;
